module.exports = __webpack_public_path__ + "static/img/bg5.6f532b5e.jpg";